import { render } from "./SwitchInput.vue?vue&type=template&id=04457aa2&scoped=true&ts=true"
import script from "./SwitchInput.vue?vue&type=script&lang=ts"
export * from "./SwitchInput.vue?vue&type=script&lang=ts"

import "./switch-input.scss?vue&type=style&index=0&id=04457aa2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04457aa2"]])

export default __exports__